import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import '@xyflow/react/dist/style.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// HMR API to ignore updates for the specific file
if (import.meta.hot) {
  import.meta.hot.accept('./src/index.css', (/** @type {any} */ mod) => {
    // Optional: add custom handling here if needed, otherwise leave it empty
    // to just prevent a full page reload.
  })
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
)
// ReactDOM.createRoot(document.getElementById('root')!).render(
//   <React.StrictMode>
//     <QueryClientProvider client={queryClient}>
//       <App />
//     </QueryClientProvider>
//   </React.StrictMode>,
// )
